import React, {useEffect, useRef, useState} from 'react'
import {useNavigate, useSearchParams} from "react-router-dom";
import styled from "styled-components";
import {Button, Form, message, notification, Modal} from "antd";
import {CustomInput} from "../../components/CustomForm";
import {useTranslation} from "react-i18next";
import {useMutation} from "react-query";
import {
  emailExists,
  getWalletLoginVerificationCode,
  walletEmailBind
} from "../../api/User";
import _debounce from "lodash/debounce";
import {setToken, setTwoFA, setUser} from "../../features/user/userSlice";
import {useDispatch} from "react-redux";

const Title = styled.h2`
  font-size: 32px;
  color: #fff;
`;

const Container = styled.div`
  width: 495px;
  min-height: calc(100vh - 184px);
  display: flex;
  flex-direction: column;
  justify-content: center;
`

const VerificationTips = styled.div`
  position: absolute;
  right: 35px;
  top: 0;
  line-height: 45px;
  cursor: pointer;
  z-index: 2;

  span {
    /* width: 120px; */
    color: #18eac4;
    font-size: 12px;
    line-height: 1.5;
    display: inline-block;
    /* padding-bottom: 1px; */
  }

  span:hover {
    border-bottom: 1px solid #18eac4;
  }

  .second-tips {
    color: #fff;
    font-size: 12px;
    line-height: 1.5;
    display: inline-block;
    width: 120px;
    text-align: center;
  }
`

const After = ({ setVerificationKey, form }) => {
  const [state, setState] = useState(61);
  const Timer = useRef(null);
  const {mutate: emailExistsMutate, data: emailExistsData} = useMutation(emailExists)

  const startTimer = () => {
    Timer.current = setInterval(() => {
      setState((prve) => prve - 1);
    }, 1000);
  };

  const sendVerificationCode = async () => {
    const res = await getWalletLoginVerificationCode(form.getFieldValue('email'));
    if (res && res.code === '10000' && res.data) {
      setVerificationKey(res.data.key);
      message.success('Verification code has been sent');
      setState((prve) => prve - 1);
      startTimer();
    }
  };

  const checkEmail = () => {
    const error = form.getFieldError('email')
    const value = form.getFieldValue('email')
    if (!error.length && value) {
      emailExistsMutate(value)
    }
  }

  const showModal = () => {
    Modal.confirm({
      type: "warn",
      className: 'custom-modal',
      title: 'This email has been bound with another account. Do you want to merge it with the current account?',
      onOk: (close) => {
        sendVerificationCode().then(close)
      },
    })
  }

  useEffect(() => {
    if (emailExistsData) {
      if (emailExistsData.data.email_exists) {
        showModal()
      } else {
        sendVerificationCode().then()
      }
    }
  }, [emailExistsData])

  useEffect(() => {
    if (state <= 0 && Timer.current) {
      clearInterval(Timer.current);
      setState(61);
    }
  }, [state]);

  return (
      <VerificationTips>
        {state >= 61 || state === 0 ? (
            <span
                onClick={_debounce(checkEmail, 5000, {
                  leading: true,
                  trailing: false,
                })}
            >
          Send Verification Code
        </span>
        ) : (
            <div className="second-tips">{state}s</div>
        )}
      </VerificationTips>
  );
};

export const WalletEmailBind = () => {
  const [params] = useSearchParams()
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [verificationKey, setVerificationKey] = useState()
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const {mutate: walletEmailBindMutate, data: walletEmailBindData, isLoading: walletEmailBindLoading} = useMutation(walletEmailBind)

  const onFinish = (values) => {
    walletEmailBindMutate({
      ...values,
      verification_key: verificationKey,
      email_bind_key: params.get('bindKey'),
      address: params.get('address'),
    })
  }

  useEffect(() => {
    if (walletEmailBindData) {
      const {data, code} = walletEmailBindData
      //2-FA校验
      if(data.user.two_fa){
        navigate(`/login/2fa?id=${data.user.id}`);
        return;
      }

      if (code === '10000') {
        message.success(t('loginPage.message.success')).then();
        if (!data.user.wallet_address && data.user.type !== 1) {
          notification.warning({
            key:'warning',
            message: '',
            description: (
                <span
                    style={{
                      fontSize: '16px',
                    }}
                >
                  Please set your wallet address before submitting your report.
                </span>
            ),
            duration: 5000,
            btn: (
                <Button
                    size="small"
                    style={{
                      height: '32px',
                      backgroundColor: '#18EAC4',
                      borderColor: '#18EAC4',
                      color: '#000',
                      borderRadius: '6px',
                    }}
                    onClick={() => {
                      notification.close('warning');
                      navigate('/user?page=my_info', { state: { wallet_address: true } });
                    }}
                >
                  Setting
                </Button>
            ),
          });
          setTimeout(() => {
            navigate('/');
          }, 2000);
        }else if(params.get('redirect_url')){
          if(params.get('redirect_url') !== '/login'){
            navigate(params.get('redirect_url'));
          }
          navigate('/');
        }else{
          setTimeout(() => {
            navigate('/');
          }, 2000);
        }

        dispatch(setUser(data));
        dispatch(setToken(`${data.type} ${data.token}`));
        dispatch(setTwoFA(data.user.two_fa));
      }
    }
  }, [walletEmailBindData])

  return (
      <Container>
        <Title>{t('walletEmailBind.Bind mailbox')}</Title>
        <Form
            form={form}
            onFinish={onFinish}
            autoComplete="off">
          <Form.Item
              name="email"
              rules={[
                { required: true, message: 'Please input your email' },
                { type: 'email', message: 'The input is not valid email' },
              ]}
          >
            <CustomInput
                placeholder={t('user_center.CompanyInfo.Email')}
            />
          </Form.Item>
          <Form.Item>
            <Form.Item
                name="verification_code"
                hasFeedback
                rules={[
                  { required: true, message: 'Please input Verification Code' },
                ]}
            >
              <CustomInput
                  className={'verification-code-container'}
                  placeholder={t('CompanyRegisterPage.VerificationCode')}
              />
            </Form.Item>
            <After setVerificationKey={setVerificationKey} form={form} />
          </Form.Item>
          <Form.Item>
            <Button
                type="primary"
                htmlType="submit"
                loading={walletEmailBindLoading}
                style={{
                  height: '42px',
                  backgroundColor: '#18EAC4',
                  borderColor: '#18EAC4',
                  color: '#000',
                  borderRadius: '4px',
                }}
            >
              {t('user_center.setPassword.submit')}
            </Button>
          </Form.Item>
        </Form>
      </Container>
  )
}
